/**
 * Runtime helpers to access THREE.js classes.
 *
 * These use direct ES module imports from 'three' instead of
 * accessing THREE through the Potree global.
 */

import * as THREE from 'three';

/**
 * Check if THREE.js is available.
 * With direct imports this always returns true, but kept for backward compatibility
 * with guard checks in consuming code.
 */
export function isPotreeThreeAvailable(): boolean {
  return !!THREE;
}

// Vector3
export function createVector3(x = 0, y = 0, z = 0) {
  return new THREE.Vector3(x, y, z);
}

// Vector2
export function createVector2(x = 0, y = 0) {
  return new THREE.Vector2(x, y);
}

// Color - accepts various formats like THREE.Color
export function createColor(rOrHex?: number | string | THREE.Color, g?: number, b?: number) {
  if (g !== undefined && b !== undefined) return new THREE.Color(rOrHex as number, g, b);
  return new THREE.Color(rOrHex as number | string | THREE.Color);
}

// Box3
export function createBox3() {
  return new THREE.Box3();
}

// Group
export function createGroup() {
  return new THREE.Group();
}

// Object3D
export function createObject3D() {
  return new THREE.Object3D();
}

// Euler
export function createEuler(x = 0, y = 0, z = 0, order: THREE.EulerOrder = 'XYZ') {
  return new THREE.Euler(x, y, z, order);
}

// Quaternion
export function createQuaternion(x = 0, y = 0, z = 0, w = 1) {
  return new THREE.Quaternion(x, y, z, w);
}
